import { cn } from "../../../../../utils/classnames";

/**
 * Centred heading that opens a sub-service (Airport Transfer, Business
 * Transfer, Private Tour): a small gold kicker, a serif title, a hairline rule
 * and an intro paragraph.
 *
 * Hairlines take no space in Figma but 1px here, so the gap above each rule
 * (in both headings below) is 1px less than the design value.
 */
export const SectionHeading = ({ kicker, title, intro, className }) => (
  <div className={cn("tw:text-center", className)}>
    <div className="tw:font-hanken-grotesk tw:font-semibold tw:uppercase tw:tracking-[3px] tw:text-[10px] tw:leading-[14px] tw:text-[#9A7B3F]">
      {kicker}
    </div>

    <div className="tw:font-libre-caslon-display tw:font-normal tw:text-[#282828] tw:text-[28px] tw:lg:text-[36px] tw:leading-[38px] tw:lg:leading-[48px] tw:mt-3">
      {title}
    </div>

    <div className="tw:h-px tw:w-[120px] tw:lg:w-[188px] tw:mx-auto tw:bg-[#F1F1F1] tw:mt-6 tw:lg:mt-[35px]" />

    {intro && (
      <div className="tw:max-w-[660px] tw:mx-auto tw:mt-6 tw:lg:mt-9 tw:font-hanken-grotesk tw:text-[#4E4E4E] tw:text-[14px] tw:leading-[20px]">
        {intro}
      </div>
    )}
  </div>
);

/**
 * Left-aligned title for a block inside a section (e.g. "Concierge Service"),
 * followed by a short hairline. The copy that follows goes in `children`.
 */
export const BlockHeading = ({ title, children, className }) => (
  <div className={className}>
    <div className="tw:font-hanken-grotesk tw:font-semibold tw:text-[18px] tw:leading-[25px] tw:text-[#282828]">
      {title}
    </div>
    <div className="tw:h-px tw:w-[100px] tw:bg-[#F1F1F1] tw:my-6 tw:lg:mt-[31px] tw:lg:mb-8" />
    {children}
  </div>
);
